import GlobalThemeProvider from './GlobalThemeProvider';

export default GlobalThemeProvider;
